import React, { Component } from 'react';
import SideNavUi from '../../presentational/Layout/SideNav.component'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class SideNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    getBreakDetail() {

    }

    render() {
        return (
            <SideNavUi
                showPage={this.showPage.bind(this)}
                mainMenuState={this.props.mainMenuState}
            />
        );
    }

    showPage(e, title) {
        this.props.getPageTitle(e, title)
    }
}
const mapStateToProps = () => {
    return {

    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({

    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(SideNavigation);